export default {
  SearchAutocomplete__TEXT: "Search",
};
